export const LOGIN_OTP_SUBMIT_START = 'LOGIN_OTP_SUBMIT_START';
export const LOGIN_OTP_SUBMIT_SUCCESS = 'LOGIN_OTP_SUBMIT_SUCCESS';
export const LOGIN_OTP_SUBMIT_FAIL = 'LOGIN_OTP_SUBMIT_FAIL';
export const LOGIN_OTP_SUBMIT_RESET = 'LOGIN_OTP_SUBMIT_RESET';

export const LOGIN_OTP_RESEND_START = 'LOGIN_OTP_RESEND_START';
export const LOGIN_OTP_RESEND_SUCCESS = 'LOGIN_OTP_RESEND_SUCCESS';
export const LOGIN_OTP_RESEND_FAIL = 'LOGIN_OTP_RESEND_FAIL';
export const LOGIN_OTP_RESEND_RESET = 'LOGIN_OTP_RESEND_RESET';
